export default __webpack_public_path__ + "static/media/foto10.8062577b.jpg";